export const colours = [
    { name: "default", colors: ["#8ecae6", "#219ebc", "#023047"], textColor: "black" },
    { name: "one", colors: ["#cdb4db", "#ffc8dd", "#ffafcc"], textColor: "black" },
    { name: "two", colors: ["#003049", "#d62828", "#f77f00"], textColor: "white" },
    { name: "three", colors: ["#9b5de5", "#f15bb5", "#fee440"], textColor: "white" },
    { name: "four", colors: ["#ff595e", "#ffca3a", "#8ac926"], textColor: "white" },
    { name: "five", colors: ["#fff3b0", "#335c67", "#e09f3e"], textColor: "black" },
    { name: "six", colors: ["#dee2e6", "#f8f9fa", "#e9ecef"], textColor: "black" },
    { name: "seven", colors: ["#17b68a", "#035e7b", "#f5bb00"], textColor: "white" },
    { name: "eight", colors: ["#0c0f0a", "#ff206e", "#fbff12"], textColor: "white" },
    { name: "nine", colors: ["#7bdff2", "#b2f7ef", "#eff7f6"], textColor: "black" },
    { name: "ten", colors: ["#ff99c8", "#fcf6bd", "#d0f4de"], textColor: "black" },
    { name: "eleven", colors: ["#0a2463", "#3e92cc", "#d8315b"], textColor: "white" },
    { name: "twelve", colors: ["#a1cca5", "#8fb996", "#709775"], textColor: "black" },
    { name: "thirteen", colors: ["#2d3142", "#4f5d75", "#bfc0c0"], textColor: "white" },
    { name: "fourteen", colors: ["#2a9d8f", "#264653", "#e9c46a"], textColor: "white" },
] 